import React, {useRef, useContext} from "react";

import { A11y } from "@churchofjesuschrist/eden-buttons";
import { Callout } from "@churchofjesuschrist/eden-callout";
import { Profile } from "@churchofjesuschrist/eden-icons";
import { spacing16, backgroundColorLevelCurrent } from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

import useSwitch from "../../generic/hooks/use-switch/use-switch";
import MobileViewContext from "../mobile/mobile-view-context";

const CalloutContent = styled.div`
  padding: ${spacing16} ${spacing16} 0 ${spacing16};
  color: black;
  ${({isMobile}) => isMobile ? "width:calc(100vw);" : ""}
`;
const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  color: ${backgroundColorLevelCurrent};
`;

const ButtonContents = styled.div`
  display: flex;
  align-items: center;
  color: ${backgroundColorLevelCurrent};
`;
const UserNameHolder = styled.span`
  display: inline-block;
  margin-right: 0.25rem;
  align-self: center;
`;
const IconHolder = styled.span`
  font-size: 2rem;
  margin-bottom: -0.4rem;
  margin-right: 0.5rem;
  color: ${backgroundColorLevelCurrent};
`;

const TopBarUserMenu = ({ children = () => { }, startOpen, user = {}}) => {

  const [open, openMenu,closeMenu] = useSwitch(startOpen);
  const {isMobile} = useContext(MobileViewContext) || {};

  const menuRef = useRef();

  return (
    <Container data-id="user-menu">
      <A11y onClick={openMenu} ref={menuRef}>
        <ButtonContents>
          {!isMobile && <UserNameHolder>{user.name}</UserNameHolder>}
          <IconHolder>
            <Profile />
          </IconHolder>
        </ButtonContents>
      </A11y>
      <Callout open={open} forRef={menuRef}
        onClickOutside={closeMenu}>
        <CalloutContent isMobile={isMobile}>{children(closeMenu)}</CalloutContent>
      </Callout>
    </Container>
  );
}


export default TopBarUserMenu;
